<template>
  <div
    v-editable="blok"
    class="SingleMarketContactBox bg-bg-base border border-border-subtle p-20 desk:p-24"
  >
    <div v-if="blok.label" class="type-tagline-xs text-text-errorStrong mb-8">
      {{ blok.label }}
    </div>
    <component
      :is="blok.headerTag ?? 'h2'"
      v-if="blok.title"
      class="type-headline-base mb-4"
    >
      {{ blok.title }}
    </component>
    <div v-if="blok.city" class="type-tagline-xs text-text-subtle mb-12">
      {{ blok.city }}
    </div>
    <div
      v-if="blok.description"
      class="type-sm text-text-subtle mb-16"
    >
      {{ blok.description }}
    </div>
    <div class="flex flex-col gap-8">
      <div v-if="blok.address" class="flex items-start gap-8">
        <img
          src="/icons/location.svg"
          class="w-16 h-16 mt-2 shrink-0 opacity-60"
          alt=""
        >
        <span class="type-sm whitespace-pre-line">{{ blok.address }}</span>
      </div>
      <div v-if="blok.phone" class="flex items-center gap-8">
        <img
          src="/icons/phone.svg"
          class="w-16 h-16 shrink-0 opacity-60"
          alt=""
        >
        <a
          :href="`tel:${blok.phone}`"
          class="type-sm"
        >
          {{ blok.phone }}
        </a>
      </div>
      <div v-if="blok.email" class="flex items-center gap-8">
        <img
          src="/icons/mail.svg"
          class="w-16 h-16 shrink-0 opacity-60"
          alt=""
        >
        <a
          :href="`mailto:${blok.email}`"
          class="type-sm"
        >
          {{ blok.email }}
        </a>
      </div>
      <div v-if="websiteDisplay" class="flex items-center gap-8">
        <img
          src="/icons/globe.svg"
          class="w-16 h-16 shrink-0 opacity-60"
          alt=""
        >
        <NuxtLink
          :to="$sbLinkFix(blok.website)"
          :target="$sbLinkTarget(blok.website)"
          class="type-xs-medium"
        >
          {{ websiteDisplay }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StoryBlokPropBase, StoryBlokLink, DatasourceHeadlineTypes } from '#constants/types/storyblok';

export interface StoryBlokSingleMarketContactBox extends StoryBlokPropBase {
  component: 'SingleMarketContactBox';
  label: string;
  title: string;
  headerTag?: DatasourceHeadlineTypes;
  city?: string;
  description: string;
  address: string;
  phone: string;
  email: string;
  website: StoryBlokLink;
}

const props = defineProps<{
  blok: StoryBlokSingleMarketContactBox;
}>();

const { $sbLinkFix, $sbLinkCheck, $sbLinkTarget } = useNuxtApp();

const websiteDisplay = computed(() => {
  const link = props.blok.website;
  if (!link) { return ''; }
  const url = link.url || '';
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
});
</script>
